import { useEffect, useRef, useState } from 'react';
import WebProductOrderEdit from './WebProductOrderEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import dayjs from 'dayjs';
import { Button, Space, Tooltip } from 'antd';
import WebOrderPayEdit from "./WebOrderPayEdit";
import WebConsign from "./WebConsign";
import antdMessage from '../../../utilsTsx/components/system/antdMessage';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';

/**
 * 组件 WebProductOrder 
 * @param props 
 * @returns 
 */
const WebProductOrder = (props: any) => {
    const apiId = 'webProductOrder';
    const ref = useRef<any>(undefined);
    const [modalVisibleWebOrderPayEdit,
        setModalVisibleWebOrderPayEdit] = useState(false);
    const [modalData, setModalData] = useState({});
    const [modalVisibleWebConsign,
        setModalVisibleWebConsign] = useState(false);
    const [orderStatusData, setOrderStatusData] = useState<any>();
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [defaultService, setDefaultService] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setFetchData(() => ref.current.fetchData);
            setSendPageData(ref.current.sendPageData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'orderStatus',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { orderStatus } = res.data;
                    setOrderStatusData([{ id: 'ALLITEM', name: '所有状态' }, ...orderStatus]);
                }
            })
    }, []);

    let sendData = {
        type: '',
        id: '',
        productOrderId: ''
    }

    //打开[新增-编辑]框
    const openModal = (type: string, id: string, productOrderId: string) => {
        sendData.type = type;
        sendData.id = id;
        sendData.productOrderId = productOrderId;
        setModalData(sendData);
        setModalVisibleWebOrderPayEdit(true);
    }

    //编辑
    const handleOrderPayEdit = (recordData: any) => {
        let id = recordData.orderPayId;
        let productOrderId = recordData.id;
        openModal('EDIT', id, productOrderId);
    };

    //子组件回调函数，关闭modal
    const onCloseModalWebOrderPayEdit = (state: boolean) => {
        setModalVisibleWebOrderPayEdit(false)
    };

    /**
     * 表头内容
     */
    const columnsHead = [
        // {
        //     title: '微信用户',
        //     dataIndex: 'nickName',
        //     render: (text: any, record: any) =>
        //     (record.wxUser.nickName +
        //         (record.wxUser.mobile ? '(' + record.wxUser.mobile + ')' : ''))
        // },
        {
            title: '店铺',
            dataIndex: 'shop',
            render: (val: any) => val?.shopName
        },
        {
            title: '订单状态',
            dataIndex: 'orderStatus',
            render: (val: any) => val?.name
        },
        {
            title: '支付单号',
            dataIndex: 'orderPayId',
            render: (val: any, record: any) => <Tooltip placement="topLeft" title={val}>
                <Button size={"small"} type="primary" onClick={() => handleOrderPayEdit(record)}>
                    {(typeof val !== "undefined" && val !== null) ?
                        (val.length >= 8 ? '......' + val.substring(val.length - 8, val.length) : val)
                        : ''
                    }
                </Button>
            </Tooltip>
        },
        {
            title: '下单时间',
            dataIndex: 'createdAt',
            render: (val: any, record: any) =>
                <span>
                    {dayjs(record.sysDate.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
        },
        {
            title: '最后收货确认',
            dataIndex: 'lastReceiptDate',
            render: (val: any, record: any) =>
                <span>
                    {dayjs(record.lastReceiptDate).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
        },
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /**
     * 物流发货按钮
     * @param record 
     * @returns 
     */
    const consignButton = (record: any) => {
        return (<>
            {record.productStatusId === 1 ?
                <Tooltip placement="topLeft" title={'查看或修改物流信息'}>
                    <Button
                        type="dashed"
                        onClick={() => consigning(record, 'Edit')}>
                        {record.productStatus_Name}
                    </Button>
                </Tooltip> :
                record.productStatus_Name}
        </>)
    };

    /**
     * 关闭发货窗口
     */
    const onCloseWebConsign = () => {
        setModalVisibleWebConsign(false);
    }

    /**
     * 发货或查看
     * @param record 
     * @param type Edit Or Add
     */
    const consigning = (record: any, type: string) => {
        const sendObj = {
            type,
            productOrderId: record.productOrderId,
            productOrderDetailId: record.id,
            logisticsOrderId: record.logisticsOrderId
        }
        setModalData(sendObj);
        setModalVisibleWebConsign(true);
    };

    /** 子表头内容 */
    const expandableColumnsHead = [
        {
            title: '名称',
            dataIndex: 'productName',
            render: (val: any, record: any) => <Tooltip placement="topLeft" title={record.id}>{
                val
            }</Tooltip>
        },
        {
            title: '规格',
            dataIndex: 'productPriceSpec',
            render: (val: any) => <Tooltip placement="topLeft" title={val}>{
                (typeof val !== "undefined" && val !== null) ?
                    (val.length >= 8 ? val.substring(0, 8) + '......' : val)
                    : ''
            }</Tooltip>
        },
        {
            title: '价格',
            dataIndex: 'price',
        },
        {
            title: '成交价',
            dataIndex: 'purchasePrice',
        },
        {
            title: '数量',
            dataIndex: 'amount',
        },
        {
            title: '单位',
            dataIndex: 'productUnit',
        },
        {
            title: '金额',
            dataIndex: 'totalPurchasePrice',
        },
        {
            title: '产品状态',
            dataIndex: 'productStatus_Name',
            render: (val: any, record: any) =>
            (<Tooltip placement="topLeft" title={record.productStatusId === 2 ? dayjs(record.receiveDate).format('YYYY-MM-DD HH:mm:ss') : ''}>{
                consignButton(record)
            }</Tooltip>
            )
        },
        {
            title: '',
            dataIndex: 'chargebackStatus_Name',
        },
        {
            title: '退换规则',
            dataIndex: 'productReturnRules_Name'
        },
        {
            title: '退单',
            dataIndex: 'id',
            render: (val: any, record: any) => {
                return ((typeof val !== 'undefined' &&
                    record.chargebackStatusId !== -1 &&
                    record.chargebackStatusId !== -2) ?
                    <>
                        <Button type='primary' onClick={() => {
                            fetchApi.POST(defaultService,
                                {
                                    body: {
                                        apiId: 'wxChargeback',
                                        apiData: {
                                            productOrderDetailId: val, //订单详情id
                                            chargebackTypeId: 1, //退单类型id
                                            refundAmount: record?.totalPurchasePrice, //退款金额(不超过货品金额)
                                            chargebackReasonId: -1, //退单原因id
                                            memo: '系统退单' //备注
                                        }
                                    }
                                }).then(res => {
                                    if (res.success === true) {
                                        console.log(res.data);
                                        antdMessage('success', '已新增退单！');
                                        fetchData?.();
                                    } else {
                                        antdMessage('error', `无法新增退单，${res.message}`);
                                    }
                                })

                        }}>{'退单'}</Button>
                    </> : undefined
                )
            }
        },
        {
            title: '销售',
            dataIndex: 'sales',
            render: (val: any) => (
                val ? (
                    <Tooltip placement="topLeft" title={val.id}>{val.salesName}</Tooltip>
                ) : ''
            )
        },
    ];

    /** 子表头 */
    const expandableColumns = expandableColumnsHead;

    /**
     * 扩展Props
     */
    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '产品',
        apiId,
        columns,
        editOptions: {
            Editor: WebProductOrderEdit
        },
        displayOptions: {
            showAdd: false
        },
        expandableOptions: {
            isTree: true,
            subColumns: expandableColumns,
            subDataName: 'productOrderDetails'
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='orderStatusId'
                    getListData={orderStatusData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalVisibleWebOrderPayEdit ? (<WebOrderPayEdit closeModal={onCloseModalWebOrderPayEdit} data={modalData} />) : null}
            {modalVisibleWebConsign ? (<WebConsign onClose={onCloseWebConsign} data={modalData} />) : null}
        </>
    )
}

export default WebProductOrder;